import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

/**
 * Registra el historial de URLs visitadas dentro de la SPA.
 * Se instancia al arranque (inyectado en AppComponent) para capturar toda la navegación.
 */
@Injectable({ providedIn: 'root' })
export class NavigationHistoryService {

    /** Últimas URLs visitadas (la última es la actual). */
    private history: string[] = [];
    private readonly maxEntries = 50;

    constructor(private router: Router) {
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                const url = event.urlAfterRedirects || event.url;
                // Evita duplicar la misma URL de forma consecutiva.
                if (this.history[this.history.length - 1] !== url) {
                    this.history.push(url);
                    if (this.history.length > this.maxEntries) {
                        this.history.shift();
                    }
                }
            });
    }

    /**
     * Devuelve la última URL visitada que NO empiece por `basePath`.
     * Útil para un botón "Volver" que debe salir de un módulo/dominio,
     * ignorando la navegación interna entre sus subvistas.
     */
    getLastUrlOutside(basePath: string): string | null {
        // Recorre el historial de atrás hacia adelante, saltando la URL actual.
        for (let i = this.history.length - 2; i >= 0; i--) {
            const url = this.history[i];
            if (!url.split('?')[0].startsWith(basePath)) {
                return url;
            }
        }
        return null;
    }
}
